
export default (token, page, params) => {
    switch (page) {
        case "student":
        case "voluntary":
        case "teacher":
            if (token.from_user != params.id) return false
        break;
    }
    return true
}